import React from 'react';
import Checkbox from '@material-ui/core/Checkbox'
import IconButton from '@material-ui/core/IconButton'
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AddContact from '../../AddContact/index';
import Divider from "@material-ui/core/Divider";
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import {withStyles} from "@material-ui/core/styles";
import {green} from "@material-ui/core/colors";
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';
import {editagent, savecontact} from '../../../../api/api' ;

function toPersianNum(num, dontTrim) {

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
};

const styles = theme => ({


    root: {
        fontFamily: 'iransans',
        padding: '20px 10px',
        '& .MuiTextField-root': {
            width: '100%',
            fontFamily: 'iransans',
        },
        '& .MuiAlert-message': {

            fontFamily: 'iransans',
        },


        '& .MuiFormHelperText-root': {

            fontFamily: 'iransans',
            marginTop: 5,
            marginLeft: 0


        },


        '& .MuiTypography-root': {

            fontFamily: 'iransans',
        },

        '& .MuiListItemText-secondary': {

            fontFamily: 'iransans',
            marginTop: 10,
        },

        '& .MuiTypography-body1': {

            fontFamily: 'iransans',

        },


        '& .MuiTypography-h6': {

            fontFamily: 'iransans',

        },
        '& .MuiButton-root': {

            fontFamily: 'iransans',

        },
        '& .MuiTypography-colorTextSecondary': {
            color: '#222'
        }
        // '& .MuiListItem-button': {
        //
        //     fontFamily: 'iransans',
        //    border:'1px solid #dadada',
        //   borderRadius: 4,
        //
        // },

    },


    input: {
        fontFamily: 'iransans',
        width: '100%',

    }, buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    }


});


class ContactCellAgent extends React.Component {


    onContactOptionSelect = event => {
        this.setState({menuState: true, anchorEl: event.currentTarget});
    };
    handleRequestClose = () => {
        this.setState({menuState: false});
    };
    onContactClose = () => {
        this.setState({addContactState: false});
    };
    onDeleteContact = (contact) => {
        this.setState({addContactState: false});
        this.props.onDeleteContact(contact);
    };
    onEditContact = () => {
        this.setState({menuState: false, addContactState: true});
    };
    onSaveEdit = () => {

        this.setState({loader: true});

        var body = new FormData();
        body.append('id', this.state.id);
        body.append('name', this.state.name);
        body.append('email', this.state.email);
        body.append('password', this.state.password);
        // body.append('Mobile2',this.state.mob2);

        editagent(body)
            .then((response) => {
                if (response.data.errorCode === 0) {

                    this.setState({loader: false});
                    this.setState({addContactState: false});
                    this.props.onupdate();
                    //setAddContactState(false);


                }
            })
            .catch((error) => {


            })


    };


    constructor(props) {
        super(props);
        this.state = {
            anchorEl: undefined,
            menuState: false,
            loader: false,
            addContactState: false,
            openadd: false,
            name: this.props.contact.Name,
            email: this.props.contact.email,
            mob1: this.props.contact.Mobile1,
            mob2: this.props.contact.Mobile2,
            password: '',
            repassword: '',
            id: this.props.contact.id,
        }
    }

    render() {
        const {contact, addFavourite, classes, onContactSelect, onSaveContact} = this.props;
        const {
            menuState,
            anchorEl,
            addContactState,
            openadd,
            name,
            email,
            mob2,
            loader,
            id,
            password,
            repassword
        } = this.state;
        const {Name, Mobile1, Mobile2} = contact;

        const options = [
            'ویرایش',
            'حذف',
        ];
        return (

            <div className={`contact-item ${classes.root}`}>

                {/*<Checkbox color="primary"*/}
                {/*checked={contact.selected}*/}
                {/*value="checkedF"*/}
                {/*onClick={() => {*/}
                {/*onContactSelect(contact)*/}
                {/*}}*/}
                {/*/>*/}
                {/*<div className="col-auto px-1 actions d-none d-xs-flex">*/}
                {/*<IconButton className="icon-btn p-1" onClick={() => {*/}
                {/*addFavourite(contact)*/}
                {/*}}>*/}
                {/*{starred ? <i className="zmdi zmdi-star"/> : <i className="zmdi zmdi-star-outline"/>}*/}
                {/*</IconButton>*/}
                {/*</div>*/}
                {/*{(thumb === null || thumb === '') ?*/}
                {/*<div className="rounded-circle size-40 bg-blue text-center text-white mx-1 mx-md-3"*/}
                {/*style={{fontSize: 20}}>*/}
                {/*{name.charAt(0).toUpperCase()}*/}
                {/*</div> :*/}
                {/*<img className="rounded-circle size-40 mx-1 mx-md-3" alt={name} src={thumb}/>}*/}


                <ListItemAvatar>
                    <Avatar alt="Remy Sharp"/>
                </ListItemAvatar>
                <div style={{display: 'flex', fontFamily: 'iransans', flexDirection: 'column'}}>
                    <ListItemText style={{fontFamily: 'iransans'}} primary={Name}/>
                    {/*<ListItemText style={{fontFamily: 'iransans'}}*/}
                    {/*              primary={toPersianNum(Mobile1)}/>*/}
                </div>


                {/*<div className="col con-inf-mw-100">*/}
                {/*<p className="mb-0">*/}
                {/*<span className="text-truncate contact-name text-dark iran-font">*/}
                {/*{Name}*/}
                {/*</span>*/}
                {/*/!*<span className="d-inline-block toolbar-separator">&nbsp;</span>*!/*/}
                {/*/!*<Divider style={{height: 28,*!/*/}
                {/*/!*margin: 4}} orientation="vertical"/>*!/*/}

                {/*<span className="text-truncate job-title text-dark iran-font ml-4">*/}
                {/*{toPersianNum(Mobile1)}*/}
                {/*</span>*/}
                {/*</p>*/}

                {/*/!*<div className="text-muted">*!/*/}
                {/*/!*<span className="email d-inline-block mr-2">*!/*/}
                {/*/!*{Name},*!/*/}
                {/*/!*</span>*!/*/}

                {/*/!*<span className="phone d-inline-block">*!/*/}
                {/*/!*{Mobile1}*!/*/}
                {/*/!*</span>*!/*/}
                {/*/!*</div>*!/*/}
                {/*</div>*/}


                <div className="col-auto px-1 actions d-flex" style={{marginRight: 'auto'}}>
                    <IconButton className="icon-btn p-2" onClick={this.onContactOptionSelect}>
                        <i className="zmdi zmdi-more-vert"/>
                    </IconButton>

                    <Menu id="long-menu"
                          anchorEl={anchorEl}
                          open={menuState}
                          onClose={this.handleRequestClose}

                          MenuListProps={{
                              style: {
                                  width: 100,
                              },
                          }}>
                        {options.map(option =>
                            <MenuItem style={{fontFamily: 'iransans'}} key={option} onClick={() => {
                                if (option === 'ویرایش') {
                                    this.onEditContact()
                                } else {
                                    this.handleRequestClose();
                                    this.onDeleteContact(contact)
                                }
                            }
                            }>
                                {option}
                            </MenuItem>,
                        )}
                    </Menu>
                    {/*{addContactState &&*/}
                    {/*<AddContact open={addContactState} contact={contact} onSaveContact={onSaveContact}*/}
                    {/*onContactClose={this.onContactClose} onDeleteContact={this.onDeleteContact}/>}*/}

                    {addContactState &&

                    <Dialog open={addContactState} onClose={this.onContactClose} className="slideInUpTiny">
                        {/*<DialogTitle>*/}
                        {/*<div style={{fontFamily: 'iransans'}}>*/}
                        {/*ثبت مخاطب جدید*/}
                        {/*</div>*/}

                        {/*</DialogTitle>*/}

                        <div style={{
                            display: 'flex', justifyContent: 'space-between',
                            alignItems: 'center', width: '100%'
                        }}>

                            <div style={{margin: 10, fontSize: 15, fontFamily: 'iransans'}}>
                                ویرایش کارپرداز
                            </div>

                            <IconButton onClick={this.onContactClose} aria-label="Close">
                                <CloseIcon/>
                            </IconButton>


                        </div>


                        <DialogContent>
                            <div style={{
                                display: 'flex', justifyContent: 'start', flex: 1,
                                alignItems: 'start', flexDirection: 'column', width: 270,
                            }}>
                                <TextField
                                    InputProps={{
                                        classes: {
                                            root: classes.input,
                                            error: classes.input
                                        },
                                    }}
                                    InputLabelProps={{
                                        classes: {
                                            root: classes.input,
                                            error: classes.input

                                        }
                                    }}
                                    fullWidth
                                    value={name}
                                    onChange={(event) => {
                                        event.preventDefault();
                                        this.setState({name: event.target.value})
                                    }}
                                    id="name" label="نام و نام خانوادگی"
                                    type="text" variant="outlined"
                                />
                                <TextField
                                    InputProps={{
                                        classes: {
                                            root: classes.input,
                                            error: classes.input
                                        },
                                    }}
                                    InputLabelProps={{
                                        classes: {
                                            root: classes.input,
                                            error: classes.input
                                        }
                                    }}
                                    onChange={(event) => {
                                        event.preventDefault();
                                        this.setState({email: event.target.value})
                                    }}
                                    style={{marginTop: 10}}
                                    fullWidth
                                    value={email}
                                    pattern="[0-9]*"
                                    id="name" label="ایمیل"
                                    variant="outlined"
                                />

                                <TextField
                                    InputProps={{
                                        classes: {
                                            root: classes.input,
                                            error: classes.input
                                        },
                                    }}
                                    InputLabelProps={{
                                        classes: {
                                            root: classes.input,
                                            error: classes.input
                                        }
                                    }}
                                    onChange={(event) => {
                                        event.preventDefault();
                                        this.setState({password: event.target.value})
                                    }}
                                    style={{marginTop: 10}}
                                    fullWidth
                                    value={password}
                                    pattern="[0-9]*"
                                    type="password"
                                    id="name" label="کلمه عبور"
                                    variant="outlined"
                                />
                                <TextField
                                    InputProps={{
                                        classes: {
                                            root: classes.input,
                                            error: classes.input
                                        },
                                    }}
                                    InputLabelProps={{
                                        classes: {
                                            root: classes.input,
                                            error: classes.input
                                        }
                                    }}
                                    onChange={(event) => {
                                        event.preventDefault();
                                        this.setState({repassword: event.target.value})
                                    }}
                                    style={{marginTop: 10}}
                                    fullWidth
                                    value={repassword}
                                    type="password"
                                    pattern="[0-9]*"
                                    id="name" label="تکرار کلمه عبور"
                                    variant="outlined"
                                />


                                <div className="d-flex align-items-center" style={{width: '100%'}}>
                                    <Button onClick={this.onSaveEdit} disabled={loader} variant="contained"

                                            style={{
                                                width: '100%',
                                                height: 30,
                                                 backgroundColor:'#3f51b5',

                                                marginTop: 15,
                                                marginBottom: 15,
                                                flex: 1,
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                border: '1px solid ',
                                            }}
                                            className="iran-font">
                                        <div style={{fontSize: 15, color: '#fff', fontWeight: 500}}>ثبت</div>
                                        {loader &&
                                        <CircularProgress size={24} className={classes.buttonProgress}/>}
                                    </Button>
                                </div>
                            </div>
                        </DialogContent>


                        {/*<DialogActions>*/}
                        {/*<Button onClick={onContactClose} color="secondary" style={{fontFamily: 'iransans'}}>*/}
                        {/*لغو*/}
                        {/*</Button>*/}
                        {/*<Button onClick={onContactSave} color="primary" style={{fontFamily: 'iransans'}}>*/}
                        {/*ثبت*/}
                        {/*</Button>*/}
                        {/*</DialogActions>*/}
                    </Dialog>


                    }


                </div>
            </div>
        )
    }
}

export default withStyles(styles, {withTheme: true})(ContactCellAgent);
